import Model from "flarum/Model";

export default class DecorationStoreEquipment extends Model {}
Object.assign(DecorationStoreEquipment.prototype, {
  id: Model.attribute("id"),
  item_id: Model.attribute("item_id"),
  user_id: Model.attribute("user_id"),
  item_count: Model.attribute("item_count"),
  item_type: Model.attribute("item_type"),
  purchase_type: Model.attribute("purchase_type"),
  pruchase_cost: Model.attribute("purchase_cost"),
  assigned_at: Model.attribute("assigned_at"),
  item_status: Model.attribute("item_status"),
  expired_at: Model.attribute("expired_at"),
  is_expired: Model.attribute("is_expired"),
  decorationData: Model.hasOne("decorationData"),
});
